export default __webpack_public_path__ + "static/summer_containers10-f210eb1cc40420f8427ba6e118020262.webp";